  document.addEventListener('DOMContentLoaded', () => {
    // if (window.innerWidth <= 768) { }

    if(document.querySelectorAll('.mobile-facet-toggle').length > 0){
        document.querySelectorAll('.mobile-facet-toggle').forEach((btn) => { 
          btn.addEventListener('click', () => {
            // Open the main drawer
            const mobPrice = document.querySelector('.mobPriceFilter');
            const mobSort = document.querySelector('.mobSortFilter');
            const mobFilters = document.querySelector('.mobFilter');
            const mobHeading = document.querySelector('.mobile-facets__heading');

            if (btn.classList.contains('clickFilter')) {
                document.querySelectorAll('.mobFilter').forEach(function (el) {
                  el.style.display = 'block';
                  el.setAttribute('open', 'true');
              });
              mobPrice.style.display = 'none';
              mobSort.style.display = 'none';
              mobHeading.innerHTML = 'Filter';
            }
            if(btn.classList.contains('clickPrice')){
              mobPrice.style.display = 'block';
              document.querySelectorAll('.mobFilter').forEach(function (el) {
              el.style.display = 'none';
            });
              mobSort.style.display = 'none';
              mobHeading.innerHTML = 'Price';
            }
            if(btn.classList.contains('clickSort')){
              document.querySelectorAll('.mobFilter').forEach(function (el) {
                  el.style.display = 'none';
              });
              mobPrice.style.display = 'none';
              mobSort.style.display = 'block';
              mobHeading.innerHTML = 'Sort';
            }
            const mainDetails = document.querySelector('menu-drawer details');
            if (!mainDetails.hasAttribute('open')) {
              mainDetails.querySelector('summary').click(); // triggers open drawer
            }

          });
        });
    }
    
  });

/*let userTouchedPrice = false;
function updateSliderTrack(minEl, maxEl, track) {
  const min = parseFloat(minEl.min);
  const max = parseFloat(minEl.max);
  const minVal = parseFloat(minEl.value);
  const maxVal = parseFloat(maxEl.value);

  const percentMin = ((minVal - min) / (max - min)) * 100;
  const percentMax = ((maxVal - min) / (max - min)) * 100;

  track.style.background = `linear-gradient(to right, #ccc ${percentMin}%, rgba(191,93,73) ${percentMin}%, rgba(191,93,73) ${percentMax}%, #ccc ${percentMax}%)`;
}

function initDualSlider() {
  

  const minSlider = document.getElementById('Filter-Price-GTE');
  const maxSlider = document.getElementById('Filter-Price-LTE');
  const minInput = document.getElementById('min-price-input');
  const maxInput = document.getElementById('max-price-input');
  const track = document.querySelector('.slider-track');

  if (!minSlider || !maxSlider || !minInput || !maxInput || !track) return;

  const update = () => updateSliderTrack(minSlider, maxSlider, track);

  minSlider.addEventListener('input', () => {
      userTouchedPrice = true;

    let minValue = parseFloat(minSlider.value);
    let maxValue = parseFloat(maxSlider.value);
    if (minValue > maxValue) {
      minSlider.value = maxValue;
      minValue = maxValue;
    }
    minInput.value = minValue;
    update();
  });

  maxSlider.addEventListener('input', () => {
      userTouchedPrice = true;

    let minValue = parseFloat(minSlider.value);
    let maxValue = parseFloat(maxSlider.value);
    if (maxValue < minValue) {
      maxSlider.value = minValue;
      maxValue = minValue;
    }
    maxInput.value = maxValue;
    update();
  });

  minInput.addEventListener('input', () => {
    let val = parseFloat(minInput.value);
    if (!isNaN(val)) {
      minSlider.value = val;
      if (val > parseFloat(maxSlider.value)) {
        minSlider.value = maxSlider.value;
        minInput.value = maxSlider.value;
          userTouchedPrice = true;

      }
      update();
    }
  });

  maxInput.addEventListener('input', () => {
    let val = parseFloat(maxInput.value);
    if (!isNaN(val)) {
      maxSlider.value = val;
      if (val < parseFloat(minSlider.value)) {
        maxSlider.value = minSlider.value;
        maxInput.value = minSlider.value;
          userTouchedPrice = true;

      }
      update();
    }
  });

  update(); // Set initial state
}

document.addEventListener('DOMContentLoaded', initDualSlider);
document.addEventListener('ajaxContentLoaded', initDualSlider);*/

let userTouchedPrice = false;

function markUserTouched() {
  userTouchedPrice = true;
  // console.log('User touched');
}

function updateSliderTrack(minEl, maxEl, track) {
  const min = parseFloat(minEl.min);
  const max = parseFloat(minEl.max);
  const minVal = parseFloat(minEl.value);
  const maxVal = parseFloat(maxEl.value);

  const percentMin = ((minVal - min) / (max - min)) * 100;
  const percentMax = ((maxVal - min) / (max - min)) * 100;

  track.style.background = `linear-gradient(to right, #ccc ${percentMin}%, rgba(191,93,73) ${percentMin}%, rgba(191,93,73) ${percentMax}%, #ccc ${percentMax}%)`;
}

function initDualSlider() {
 // const minSlider = document.getElementById('Filter-Price-GTE');
  //const maxSlider = document.getElementById('Filter-Price-LTE');
 // const minInput = document.getElementById('min-price-input');
  let minSlider, maxSlider,minInput,maxInput,track;

  //const maxInput = document.getElementById('max-price-input');
  //const track = document.querySelector('.slider-track');
  if(document.body.classList.contains('template-search')){
      minSlider = document.getElementById('Mobile-Filter-Price-GTE');
    maxSlider = document.getElementById('Mobile-Filter-Price-LTE');
    minInput = document.getElementById('Mobile-Filter-min-price-input');
    maxInput = document.getElementById('Mobile-Filter-max-price-input');
    track = document.querySelector('.Mobile-Filter-slider-track');
  }
 else if (window.innerWidth <= 768) {
    minSlider = document.getElementById('Mobile-Filter-Price-GTE');
    maxSlider = document.getElementById('Mobile-Filter-Price-LTE');
    minInput = document.getElementById('Mobile-Filter-min-price-input');
    maxInput = document.getElementById('Mobile-Filter-max-price-input');
    track = document.querySelector('.Mobile-Filter-slider-track');
  }
  else{
    minSlider = document.getElementById('Filter-Price-GTE');
    maxSlider = document.getElementById('Filter-Price-LTE');
    minInput = document.getElementById('Filter-min-price-input');
    maxInput = document.getElementById('Filter-max-price-input');
    track = document.querySelector('.Filter-slider-track');
  }
  

  if (!minSlider || !maxSlider || !minInput || !maxInput || !track) return;

  const update = () => updateSliderTrack(minSlider, maxSlider, track);
  // console.log("SDFSDFSDFSDFSDF=============");
  [minSlider, maxSlider, minInput, maxInput].forEach((el) => {
    el.addEventListener('input', markUserTouched);
    el.addEventListener('change', markUserTouched);
  });
  [minSlider, maxSlider, minInput, maxInput].forEach(el => {
    // console.log("SDFSDFSDFSDFSDF=============");
  ['touchstart','pointerdown','mousedown','focus','click','input','change'].forEach(evt => {
    el.addEventListener(evt, (e) => console.log('EVENT ⏱', evt, 'on', e.target.id));
  });
});
  minSlider.addEventListener('input', () => {
    let minValue = parseFloat(minSlider.value);
    let maxValue = parseFloat(maxSlider.value);
    if (minValue > maxValue) minSlider.value = maxValue;
    minInput.value = minSlider.value;
    update();
  });

  maxSlider.addEventListener('input', () => {
    let minValue = parseFloat(minSlider.value);
    let maxValue = parseFloat(maxSlider.value);
    if (maxValue < minValue) maxSlider.value = minValue;
    maxInput.value = maxSlider.value;
    update();
  });

  minInput.addEventListener('input', () => {
    let val = parseFloat(minInput.value);
    if (!isNaN(val)) {
      minSlider.value = val;
      if (val > parseFloat(maxSlider.value)) {
        minSlider.value = maxSlider.value;
        minInput.value = maxSlider.value;
      }
      update();
    }
  });

  maxInput.addEventListener('input', () => {
    let val = parseFloat(maxInput.value);
    if (!isNaN(val)) {
      maxSlider.value = val;
      if (val < parseFloat(minSlider.value)) {
        maxSlider.value = minSlider.value;
        maxInput.value = minSlider.value;
      }
      update();
    }
  });

  update(); // Set initial track state
}

document.addEventListener('DOMContentLoaded', initDualSlider);
document.addEventListener('ajaxContentLoaded', initDualSlider);




class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    // Reinitialize Ajaxinate for the newly rendered product grid
    initDualSlider();
      new Ajaxinate({
        container: '.ajaxinate-container',      // Product grid container
        pagination: '#AjaxinatePagination',    // Pagination wrapper
        method: 'scroll',                       // Or 'click'
        loadingText: 'Loading'
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
   /* return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];*/
     const grid = document.getElementById('product-grid');
  if (!grid) {
    console.warn('No element found with ID "product-grid"');
    return [];
  }

  return [
    {
      section: grid.dataset.id,
    },
  ];
  }

  createSearchParams(form) {
    /*const formData = new FormData(form);
    console.log(formData.toString());
    return new URLSearchParams(formData).toString();*/
    const formData = new FormData(form);

  const params = new URLSearchParams();
  // console.log(userTouchedPrice);
  for (const [key, value] of formData.entries()) {
    if (
      (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') &&
      !userTouchedPrice
    ) {
      
      params.append(key, '');
    } else {
      params.append(key, value);
    }
  }

  return params.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
       if(url=='sort_by'){
          const currentUrl = window.location.href;
         const queryString = currentUrl.includes('?') ? currentUrl.split('?')[1] : '';
          const newurl = queryString.replace(/([?&])sort_by=[^&]*&?/, '$1').replace(/[\?&]$/, '');
         history.pushState({ newurl }, '', `${window.location.pathname}${newurl && '?'.concat(newurl)}`);
          FacetFiltersForm.renderPage(newurl);
         
         //FacetFiltersForm.updateURLHash(newurl);
       }else{
        // console.log(url);return false;
       FacetFiltersForm.renderPage(url);
       }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

/*class PriceRange extends HTMLElement {
  constructor() {
    super();
    
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.querySelectorAll('.range-wrap').forEach(wrap => {
      const range = wrap.querySelector(".range");
      const bubble = wrap.querySelector(".bubble");
      range.addEventListener("input", () => {
        this.setBubble(range, bubble);
      });
      this.setBubble(range, bubble);
    });
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    const wrap = event.currentTarget.closest('.range-wrap');
    const bubble = wrap?.querySelector('.bubble');
    if (bubble) {
      this.setBubble(event.currentTarget, bubble);
    }
  }

  setBubble(range, bubble) {
    const val = range.value;
    const min = range.min ? range.min : 0;
    const max = range.max ? range.max : 100;
    const newVal = Number(((val - min) * 100) / (max - min));
    bubble.innerHTML = val;
    bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  updateBubbles() {
    this.querySelectorAll('.range-wrap').forEach(wrap => {
      const range = wrap.querySelector('.range');
      const bubble = wrap.querySelector('.bubble');
      if (range && bubble) {
        this.setBubble(range, bubble);
      }
    });
  }
}*/

//customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
